export default {
  namespaced: true,

  state: {
    apiDocList: [],
    checkedCatalogCode: "product",
    apiInfo: {}
  },
  getters: {
    apiDocListMenu(state) {
      let a = state.apiDocList.map(item => {
        let children = [];
        if (item.apilist && item.apilist.length > 0) {
          children = item.apilist.map(
            cell => (cell = { ...cell, name: cell.apiCode })
          );
        }

        return { ...item, name: item.catalogCode, children: children };
      });
      return a;
    },
    checkedApiCatalogInfo(state) {
      return (
        state.apiDocList.find(
          item => item.catalogCode === state.checkedCatalogCode
        ) || {}
      );
    },
    reqPublicParam(state) {
      //公共入参
      return state.apiInfo.requestOpenPublicParam || [];
    },
    resPublicParam(state) {
      //公共出参
      return state.apiInfo.responseOpenPublicParam || [];
    },
    reqParam(state) {
      //请求参数
      return state.apiInfo.requestOpenApiParam || [];
    },
    resParam(state) {
      //相应参数
      return state.apiInfo.responseOpenApiParam || [];
    },
    reqExample(state) {
      //请求示例
      return [{ data: state.apiInfo.clientDemo }] || [];
    },
    resExample(state) {
      //响应示例
      return [{ data: state.apiInfo.responseDemo }] || [];
    },
    errorExample(state) {
      return [{ data: state.apiInfo.responseErrorDemo }] || [];
    },
    publicError(state) {
      //公共异常错误码
      return state.apiInfo.openPublicError || [];
    },
    domainError(state) {
      //业务异常错误码
      return state.apiInfo.openApiErrorDomain || [];
    },
    apiChangeHistory(state) {
      //api 变更历史
      return state.apiInfo.openApiParamBakResponse || [];
    }
  },
  actions: {
    async getApiDocList(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post("/server/portal/api/index", data);
      commit("setApiDocList", res.data.data.catalogList);
    },
    async getApiInfo(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post("/server/portal/api/apiInfo", data);
      commit("setApiInfo", res.data.data);
    }
  },

  mutations: {
    setApiDocList(state, data) {
      state.apiDocList = data;
    },
    setCatalogCode(state, data) {
      state.checkedCatalogCode = data;
    },
    setApiInfo(state, data) {
      state.apiInfo = data;
    }
  }
};
